import { TrendingUp, TrendingDown, Minus } from "lucide-react";

/**
 * Small pill that surfaces a signed numeric delta with a directional arrow.
 *
 * Props:
 *   delta:   number (can be 0 or negative)
 *   label:   string shown after the number, e.g. "this month"
 *   tone:    "positive" | "neutral"           , optional, auto by sign
 *   testId:  string                            , optional, for testing
 */
export const TrendChip = ({ delta = 0, label = "this month", tone, testId }) => {
  const numeric = Number.isFinite(delta) ? delta : 0;
  const auto =
    numeric > 0 ? "positive" : numeric < 0 ? "negative" : "neutral";
  const resolved = tone || auto;

  const palette = {
    positive: "bg-green-100 text-green-700",
    negative: "bg-rose-100 text-rose-700",
    neutral: "bg-gray-100 text-gray-600",
  }[resolved];

  const Icon =
    resolved === "positive"
      ? TrendingUp
      : resolved === "negative"
        ? TrendingDown
        : Minus;

  const formatted = numeric > 0 ? `+${numeric}` : `${numeric}`;

  return (
    <span
      className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[11px] font-bold tracking-tight ${palette}`}
      data-testid={testId}
    >
      <Icon size={12} strokeWidth={2.5} />
      {formatted}
      <span className="font-medium text-[10px] uppercase tracking-wider opacity-80 ml-0.5">
        {label}
      </span>
    </span>
  );
};

export default TrendChip;
